import { render, staticRenderFns } from "./z-checkbox.vue?vue&type=template&id=50e13dca&"
import script from "./z-checkbox.vue?vue&type=script&lang=js&"
export * from "./z-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./z-checkbox.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports